// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1AB3g","label":"Section_label__2flPq","contentWrap":"Section_contentWrap__30lvS","footer":"Section_footer__2enCe","footerInner":"Section_footerInner___qtXJ"};